// How the redesigned package grid ("Use new package layout?" --
// packages.use_new_layout) splits a pricelist's ordered options into the
// featured 3-across row and the compact "Other packages" row below it.
//
// ONE rule, read by every page that draws the V2 grid (the elementary
// OptionSelection page and the shared PackageChooser the senior flow uses).
// Keep it pure: it decides which card a parent sees first, so it is tested
// directly (__tests__/packageGridLayout.test.js).

import { hasArtwork } from '../../utils/optionArtwork';

// Two ways an Option ends up in the "Other packages" section:
//   1. It has no thumbnail (imageUrl missing / placeholder) -- the historical
//      default. Uploading a thumbnail in admin promotes it to a featured card.
//   2. Admin ticks the "Other Packages" checkbox on the option
//      (options.in_other_packages), so an Option with real artwork can stay
//      in Other packages without removing the artwork.
export const isFeaturedOption = (option) => hasArtwork(option) && !option.inOtherPackages;

// Does this pricelist draw the redesigned grid? The admin's "Use new package
// layout?" checkbox (packages.use_new_layout, `useNewLayout` on the spraypaint
// Package), or the `?ui=v2` query-string preview override. ONE predicate for
// every page that asks (PackageChooser, OptionSelectionContent).
export const usesNewLayout = (pricelist, ui) => !!pricelist?.useNewLayout || ui === 'v2';

// Returns { featured, extras } preserving the caller's order within each
// group, except that the Most Popular card (options.most_popular) is moved to
// index 1 -- the middle of a 3-across desktop row. With no Most Popular card,
// or only one featured card, the order is untouched. Never mutates `options`.
export default function partitionPackageGrid(options) {
  const list = options || [];
  const featured = list.filter(isFeaturedOption);
  const extras = list.filter((option) => !isFeaturedOption(option));

  const popularIdx = featured.findIndex((option) => option.mostPopular);
  if (popularIdx > 1 || (popularIdx === 0 && featured.length >= 2)) {
    const [popular] = featured.splice(popularIdx, 1);
    featured.splice(1, 0, popular);
  }

  return { featured, extras };
}
